import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AppConfig } from 'src/app/config/app-config';
import { AppConfigService } from 'src/app/config/app-config.service';
import { BomCookieService } from 'src/app/core/services/bom-cookie/bom-cookie.service';
import { MobileHelper } from '../../helpers/mobile-helper';

@Component({
  selector: 'bom-gdpr-modal',
  templateUrl: './gdpr-modal.component.html',
  styleUrls: ['./gdpr-modal.component.scss'],
})
export class GdprModalComponent implements OnInit, OnDestroy {
  appConfig: AppConfig;
  isGDPRModalOpen$ = new BehaviorSubject<boolean>(false);
  cookieHideGDPRName = 'hideGDPRModal';
  componentDestroyed$ = new Subject();
  form: FormGroup = new FormGroup(
    {
      hideGDPRModal: new FormControl(false),
    },
    { updateOn: 'change' }
  );
  isMobileMode = MobileHelper.isMobile();

  constructor(
    private appConfigService: AppConfigService,
    private bomCookieService: BomCookieService,
    private router: Router
  ) {}

  ngOnInit() {
    this.appConfig = this.appConfigService.getConfig();
    this.showModalBasedOnCookie();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.componentDestroyed$)
      )
      .subscribe(() => {
        this.showModalBasedOnCookie();
      });

    this.form.valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe(changes => {
      this.setHideGDPRModalValue(changes.hideGDPRModal);
    });
  }

  private showModalBasedOnCookie() {
    if (this.isMobileMode) {
      return;
    }
    const cookieHideGDPRValue = this.bomCookieService.get(this.cookieHideGDPRName);
    const showGDPRModal = cookieHideGDPRValue ? cookieHideGDPRValue === 'false' : true;
    this.isGDPRModalOpen$.next(showGDPRModal);
  }

  setHideGDPRModalValue(hideGDPRModal: boolean) {
    this.bomCookieService.set(this.cookieHideGDPRName, String(hideGDPRModal));
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
    this.componentDestroyed$.unsubscribe();
  }
}
